import { Injectable } from "@angular/core";
import { WebVoucherBalanceDataModel, SetWebVoucherModel, SetWebVoucherSuccessDataModel, RemoveWebVoucherModel, RemoveWebVoucherSuccessDataModel, WebVoucherBalanceViewModel, WebVoucherNumberLength, GetWebVoucherDataModel, GetWebVoucherModel, CreateWebVoucherDataModel } from "../shared/models/web_voucher.model";
import { CircularInjectionHelper } from "./circularInjectionHelper";
import { BonuspointsSyncModel, NewBonuspointsSyncModel, BonuspointsDataModel, BonuspointsView, BonuspointsAction, BonuspointsActionBenefit, BonuspointsErrorNumber, IBonuspoints } from "../shared/models";
import { UappErrorCode } from "./http.service";
import { LocalKeys, StorageHive } from "./valueStorage.service";
import Utils from "../shared/utils";
import DateManager from "../shared/dateManager";
import * as moment from "moment";
import { environment } from "../../../environments/environment.prod";

@Injectable()
export class WebVoucherService {

  constructor(private _objObsInjectHelper: CircularInjectionHelper) {
  }

  /**
   * Checks the WebVoucher Number
   * @param web_voucher_number Webvoucher code
   */
  public GetWebVoucherForLocation(web_voucher_number: string, location: number): Promise<GetWebVoucherDataModel> {
    const me = this;
    return new Promise<GetWebVoucherDataModel>((resolve, reject) => {
      try {
        if (me._objObsInjectHelper.coreCOMService.environment.networkInformation.isOnline) {
          const RequestData = new GetWebVoucherModel();
          RequestData.web_voucher_number = web_voucher_number;
          RequestData.location = location;
          const FunctionName = "webvoucher/GetWebVoucherForLocation";
          const DataModelConstructor = GetWebVoucherDataModel;
          me._objObsInjectHelper.yourAppServer.Api.RequestService(DataModelConstructor, FunctionName, RequestData)
            .then((response) => {
              if (response.OK) {
                resolve(response.Data);
              } else if (response.HttpResponse.ya_error_code === UappErrorCode.BLOCKED) {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucher", "RequestService (UappErrorCode.BLOCKED)", response);
                reject(parseInt(response.HttpResponse.body.message, 10)); // locked for x minutes
              } else {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucher", "RequestService (response not OK)", response);
                reject(response.HttpResponse.codeText);
              }
            })
            .catch((error) => { me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucher", "RequestService", error); reject(); });
        } else {
          me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucher", "no hasInternet");
          reject();
        }
      } catch (error) {
        me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucher", "try catch", error);
        reject();
      }
    });
  }

  /**
   * create the WebVoucher Number
   */
  public CreateWebVoucherCode(): Promise<CreateWebVoucherDataModel> {
    const me = this;
    return new Promise<CreateWebVoucherDataModel>((resolve, reject) => {
      try {
        if (me._objObsInjectHelper.coreCOMService.environment.networkInformation.isOnline) {
          const RequestData = new CreateWebVoucherDataModel();
          const FunctionName = "webvoucher/CreateWebVoucher";
          const DataModelConstructor = CreateWebVoucherDataModel;
          me._objObsInjectHelper.yourAppServer.Api.RequestService(DataModelConstructor, FunctionName, RequestData)
            .then((response) => {
              if (response.OK) {
                resolve(response.Data);
              } else {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.CreateWebVoucher", "RequestService (response not OK)", response);
                reject(response.HttpResponse.codeText);
              }
            })
            .catch((error) => { me._objObsInjectHelper.coreLogService.error("WebVoucherService.CreateWebVoucher", "RequestService", error); reject(); });
        } else {
          me._objObsInjectHelper.coreLogService.error("WebVoucherService.CreateWebVoucher", "no hasInternet");
          reject();
        }
      } catch (error) {
        me._objObsInjectHelper.coreLogService.error("WebVoucherService.CreateWebVoucher", "try catch", error);
        reject();
      }
    });
  }


  /**
   * Bind Webvoucher code to current user
   * @param web_voucher_number Webvoucher code
   */
  public SetWebVoucher(web_voucher_number: string): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      try {
        if (me._objObsInjectHelper.coreCOMService.environment.networkInformation.isOnline) {
          const RequestData = new SetWebVoucherModel();
          RequestData.web_voucher_number = web_voucher_number;
          const FunctionName = "webvoucher/SetWebVoucher";
          const DataModelConstructor = SetWebVoucherSuccessDataModel;
          me._objObsInjectHelper.yourAppServer.Api.RequestService(DataModelConstructor, FunctionName, RequestData)
            .then((response) => {
              if (response.OK) {
                me._objObsInjectHelper.yourAppServer.User.ClearData();
                me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.webVoucherBalance)
                  .catch((error) => { me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.SetWebVoucher", " _valueStorageService.remove webVoucherBalance", error); });
                resolve(response.Data.success);
              } else if (response.HttpResponse.ya_error_code === UappErrorCode.BLOCKED) {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.SetWebVoucher", "RequestService (UappErrorCode.BLOCKED)", response);
                reject(parseInt(response.HttpResponse.body.message, 10)); // locked for x minutes
              } else {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.SetWebVoucher", "RequestService (response not OK)", response);
                reject(response.HttpResponse.codeText);
              }
            })
            .catch((error) => { me._objObsInjectHelper.coreLogService.error("WebVoucherService.SetWebVoucher", "RequestService", error); reject(); });
        } else {
          me._objObsInjectHelper.coreLogService.error("WebVoucherService.SetWebVoucher", "no hasInternet");
          reject();
        }
      } catch (error) {
        me._objObsInjectHelper.coreLogService.error("WebVoucherService.SetWebVoucher", "try catch", error);
        reject();
      }
    });
  }

  public RemoveWebVoucher(web_voucher_number: string): Promise<boolean> {
    const me = this;
    return new Promise<boolean>((resolve, reject) => {
      try {
        if (me._objObsInjectHelper.coreCOMService.environment.networkInformation.isOnline) {
          const RequestData = new RemoveWebVoucherModel();
          RequestData.web_voucher_number = web_voucher_number;
          const FunctionName = "webvoucher/RemoveWebVoucher";
          const DataModelConstructor = RemoveWebVoucherSuccessDataModel;
          me._objObsInjectHelper.yourAppServer.Api.RequestService(DataModelConstructor, FunctionName, RequestData)
            .then((response) => {
              if (response.OK) {
                if (response.Data.success) {
                  me._objObsInjectHelper.yourAppServer.User.ClearData();
                  me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.remove(StorageHive.Local, LocalKeys.webVoucherBalance)
                    .catch((error) => { me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.RemoveWebVoucher", "_valueStorageService.remove webVoucherBalance", error); });
                  // todo die userdaten könnten erneut abgefragt werden, weil dort sich nun der Webgutschein nicht mehr befindet
                  console.log("todo download userdata again");
                }
                resolve(response.Data.success);
              } else if (response.HttpResponse.ya_error_code === UappErrorCode.BLOCKED) {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.RemoveWebVoucher", "RequestService (UappErrorCode.BLOCKED)", response);
                reject(parseInt(response.HttpResponse.body.message, 10)); // locked for x minutes
              } else {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.RemoveWebVoucher", "RequestService (response not OK)", response);
                reject(response.HttpResponse.codeText);
              }
            })
            .catch((error) => { me._objObsInjectHelper.coreLogService.error("WebVoucherService.RemoveWebVoucher", "RequestService", error); reject(); });
        } else {
          me._objObsInjectHelper.coreLogService.error("WebVoucherService.RemoveWebVoucher", "no hasInternet");
          reject();
        }
      } catch (error) {
        me._objObsInjectHelper.coreLogService.error("WebVoucherService.RemoveWebVoucher", "try catch", error);
        reject();
      }
    });
  }

  public GetWebVoucherBalance(): Promise<WebVoucherBalanceDataModel> {
    const me = this;
    return new Promise<WebVoucherBalanceDataModel>((resolve, reject) => {
      try {
        // if cardnumber is set (with out cardnumer it can return direct 0)
        me._objObsInjectHelper.yourAppServer.User.GetUserInfo().then((userInfo) => {
          const webvoucherNumber = userInfo.card_number ? userInfo.card_number.trim() : userInfo.card_number;
          if (webvoucherNumber && webvoucherNumber.length == WebVoucherNumberLength) {
            if (me._objObsInjectHelper.yourAppServer.coreCOMService.environment.networkInformation.isOnline) {
              const RequestData = null; // GetWebVoucherBalance dont need request data
              const FunctionName = "webvoucher/GetWebVoucherBalance";
              const DataModelConstructor = WebVoucherBalanceDataModel;
              me._objObsInjectHelper.yourAppServer.Api.RequestService(DataModelConstructor, FunctionName, RequestData)
                .then((response) => {
                  if (response.OK) {
                    me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.webVoucherBalance, response.Data)
                      .catch((error) => {
                        me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.GetWebVoucherBalance", "Api.RequestService _valueStorageService.set", error);
                      });
                    resolve(response.Data);
                  } else {
                    me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucherBalance", "RequestService (response not OK)", response);
                    reject(response.HttpResponse.codeText);
                  }
                })
                .catch((error) => { me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucherBalance", "RequestService", error); reject(); });
            } else {
              me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.webVoucherBalance)
                .then((response) => {
                  resolve(response);
                })
                .catch((error) => {
                  me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.GetWebVoucherBalance", "_valueStorageService.get", error);
                });
            }
          } else {
            // no WebVoucherNumber, so no WebVoucherBalance
            const noBalance = new WebVoucherBalanceDataModel();
            noBalance.balance = 0;
            noBalance.balance_bonus = 0;
            noBalance.discount_bonus = 0;
            resolve(noBalance);
          }
        })
          .catch((error) => {
            me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucherBalance", "yourAppServer.User.GetUserInfo", error);
          });
      } catch (error) {
        me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetWebVoucherBalance", "try catch", error);
        reject();
      }
    });
  }

  public GetWebVoucherBalanceViewModel(): Promise<WebVoucherBalanceViewModel> {
    const me = this;
    return new Promise<WebVoucherBalanceViewModel>((resolve, reject) => {
      if (me._objObsInjectHelper.yourAppServer.coreCOMService.environment.networkInformation.isOnline) {
        me.GetWebVoucherBalance()
          .then(response => {
            const webVoucherBalanceViewModel = me.mapToWebVoucherBalanceViewModel(response);
            me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.webVoucherBalance, webVoucherBalanceViewModel)
              .catch((error) => {
                me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.GetWebVoucherBalanceViewModel", "valueStorage.set", error);
              });
            resolve(webVoucherBalanceViewModel);
          })
          .catch(e => {
            me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.GetWebVoucherBalanceViewModel", "try catch", e);
            reject();
          });
      } else {
        me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.webVoucherBalance)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.GetWebVoucherBalanceViewModel", "_valueStorageService.get", error);
            reject();
          });
      }
    });
  }

  public GetWebVoucherBalanceViewModelFromStorage(): Promise<WebVoucherBalanceViewModel> {
    const me = this;
    return new Promise<WebVoucherBalanceViewModel>((resolve, reject) => {
      me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.webVoucherBalance)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          me._objObsInjectHelper.yourAppServer.coreLogService.error("WebVoucherService.GetWebVoucherBalanceViewModelFromStorage", "_valueStorageService.get", error);
          reject();
        });
    });
  }

  private mapToWebVoucherBalanceViewModel(model: WebVoucherBalanceDataModel): WebVoucherBalanceViewModel {
    if (Utils.IsNull(model)) {
      return null;
    } else {
      const viewModel = new WebVoucherBalanceViewModel();
      viewModel.balance = model.balance;
      viewModel.balanceBonus = model.balance_bonus;
      viewModel.discountBonus = model.discount_bonus;
      viewModel.walletReferenceId = model.wallet_reference_id;
      viewModel.isActive = model.wallet_active;
      viewModel.storageDate = DateManager.MomentDateTimeFormatter(moment(), true, true);
      return viewModel;
    }
  }

  public GetBounspoints(): Promise<BonuspointsDataModel> {
    const me = this;
    return new Promise<BonuspointsDataModel>((resolve, reject) => {
      try {
        // if cardnumber is set (with out cardnumer it can return direct 0)
        me._objObsInjectHelper.yourAppServer.User.GetUserInfo().then((userInfo) => {
          const webvoucherNumber = userInfo.card_number ? userInfo.card_number.trim() : userInfo.card_number;
          if (webvoucherNumber && webvoucherNumber.length == WebVoucherNumberLength) {
            const RequestData = new BonuspointsSyncModel();
            RequestData.version = 1;
            const FunctionName = "bonussystem/GetBounspoints";
            const DataModelConstructor = BonuspointsDataModel;
            me._objObsInjectHelper.yourAppServer.Api.RequestService(DataModelConstructor, FunctionName, RequestData)
              .then((response) => {
                if (response.OK) {
                  resolve(response.Data);
                  // me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.BonuspointsDataModel)
                  //   .then((prevBonusPoints) => {
                  //     if (!prevBonusPoints || (prevBonusPoints && prevBonusPoints !== response.Data)) {
                  //       me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.BonuspointsDataModel, response.Data);
                  //     }
                  //   });
                } else {
                  me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetBounsPoints", "RequestService (response not OK)", response);
                  reject(response.HttpResponse.codeText);
                }
              })
              .catch((error) => {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetBounsPoints", "RequestService", error);
                reject();
              });
          } else {
            // no WebVoucherNumber, so no Bonuspoints
            resolve(null);
          }
        })
          .catch((error) => {
            me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetBounsPoints", "yourAppServer.User.GetUserInfo", error);
          });
      } catch (error) {
        me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetBounsPoints", "try catch", error);
        reject();
      }
    });
  }

  /** Gets new bonus points from last last_point_action
   * @param last_point_action BonusPointsViewModel.lastPointAction
   * @returns BonuspointsDataModel with bonus points or emptystring, if no neu data
   */
  public GetNewBounspoints(last_point_action: string): Promise<BonuspointsDataModel> {
    const me = this;
    return new Promise<BonuspointsDataModel>((resolve, reject) => {
      try {
        // if cardnumber is set (with out cardnumer it can return direct 0)
        me._objObsInjectHelper.yourAppServer.User.GetUserInfo().then((userInfo) => {
          const webvoucherNumber = userInfo.card_number ? userInfo.card_number.trim() : userInfo.card_number;
          if (webvoucherNumber && webvoucherNumber.length == WebVoucherNumberLength) {
            const RequestData = new NewBonuspointsSyncModel();
            RequestData.version = 1;
            RequestData.last_point_action = last_point_action;
            const FunctionName = "bonussystem/GetNewBounspoints";
            const DataModelConstructor = BonuspointsDataModel;
            me._objObsInjectHelper.yourAppServer.Api.RequestService(DataModelConstructor, FunctionName, RequestData)
              .then((response) => {
                if (response.OK) {
                  resolve(response.Data);
                  // me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.BonuspointsDataModel)
                  //   .then((prevBonusPoints) => {
                  //     if (!prevBonusPoints || (prevBonusPoints && prevBonusPoints !== response.Data)) {
                  //       me._objObsInjectHelper.yourAppServer.coreCOMService.environment.valueStorage.set(StorageHive.Local, LocalKeys.BonuspointsDataModel, response.Data);
                  //     }
                  //   });
                } else {
                  me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetNewBounspoints", "RequestService (response not OK)", response);
                  reject(response.HttpResponse.codeText);
                }
              })
              .catch((error) => {
                me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetNewBounspoints", "RequestService", error);
                reject();
              });
          } else {
            // no WebVoucherNumber, so no Bonuspoints
            resolve(null);
          }
        })
          .catch((error) => {
            me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetBounsPoints", "yourAppServer.User.GetUserInfo", error);
          });
      } catch (error) {
        me._objObsInjectHelper.coreLogService.error("WebVoucherService.GetBounsPoints", "try catch", error);
        reject();
      }
    });
  }

  /** ermittelt nur das LastPointAction aus dem BonusPointString, sonst Leersting */
  public static getLastPointActionFromBonusPointString(model: IBonuspoints): string {
    let lastPointAction = ""; // initial leer, damit werden auf jedenfall Bonuspunkte abgerufen 
    if (model && !Utils.IsNull(model.bonuspoints) && model.bonuspoints.length > 0) {
      if (model.version === 1) {
        const header = model.bonuspoints.split("|");
        const header_parts = header[0].split("§"); // header[0] = header_main
        const using_int = parseInt(header_parts[0], 10); // is 1/0 or BonuspointsErrorNumber
        if (using_int == 0 || using_int == 1) {
          try {
            lastPointAction = header_parts[1]; // "dd.MM.yyyy HH:mm:ss"
          } catch (error) {
            // ignore error
          }
        }
      } else {
        // wrong version
      }
    } else {
      // no data for parsing
    }
    return lastPointAction;
  }

  public static convertBonusPointStringToBonusPointsView(model: IBonuspoints): BonuspointsView {
    const bonuspointsView: BonuspointsView = new BonuspointsView();
    bonuspointsView.hasData = false;
    if (model && !Utils.IsNull(model.bonuspoints) && model.bonuspoints.length > 0) {
      if (model.version === 1) {
        const header = model.bonuspoints.split("|");
        const header_parts = header[0].split("§"); // header[0] = header_main
        const using_int = parseInt(header_parts[0], 10); // is 1/0 or BonuspointsErrorNumber
        if (using_int > 1) { // Fehler, nur wenn > 1
          bonuspointsView.errorCode = using_int;
          bonuspointsView.errorMessage = header_parts[1]; // error masage not the date
        } else {
          try {
            bonuspointsView.using = (using_int === 1); // 1/0
            bonuspointsView.lastPointAction = header_parts[1]; // "dd.MM.yyyy HH:mm:ss"
            // todo parse lastPointAction to moment
            bonuspointsView.actions = new Array<BonuspointsAction>(header.length);
            for (let i = 1; i < header.length; ++i) {
              const action = new BonuspointsAction();
              bonuspointsView.actions[i - 1] = action;

              const act_parts = header[i].split("§"); // header[i] = bonusaction
              action.label_de = act_parts[0];
              action.id = parseInt(act_parts[1], 10);
              const points_parts = act_parts[2].split("~"); // act_parts[2] = points
              action.points = parseInt(points_parts[0], 10); // points_parts[0] = points_new
              // action.old_points = parseInt(points_parts[1], 10); // old not needed, it is only a read of current points
              action.end_day_ymd = parseInt(act_parts[3], 10); // YMD or 0

              // benefits
              const benefit_labels_de = act_parts[4].split("~");
              const benefit_product_ids = act_parts[5].split("~");
              const benefit_loss_ids = act_parts[6].split("~");
              const benefit_points = act_parts[7].split("~");
              const benefit_end_days = act_parts[8].split("~");
              action.benefits = new Array<BonuspointsActionBenefit>(benefit_labels_de.length);
              for (let j = 0; j < benefit_labels_de.length; ++j) {
                const benefit = new BonuspointsActionBenefit();
                action.benefits[j] = benefit;
                benefit.label_de = benefit_labels_de[j];
                benefit.product_id = parseInt(benefit_product_ids[j], 10);
                benefit.loss_id = parseInt(benefit_loss_ids[j], 10);
                benefit.points = parseInt(benefit_points[j], 10);
                benefit.end_day_ymd = parseInt(benefit_end_days[j], 10);  // YMD or 0
              }

              action.hide_benefit_on_receipt = (parseInt(act_parts[9], 10) === 1);
              action.text_for_receipt = act_parts[10];
            }
            // parsing was suseccsfull
            bonuspointsView.hasData = true;
            bonuspointsView.errorCode = BonuspointsErrorNumber.None;
          } catch (error) {
            // parsing error
            bonuspointsView.errorCode = BonuspointsErrorNumber.InternError;
            bonuspointsView.errorMessage = "Parsing data error";
          }
        }
      } else {
        // wrong version
        bonuspointsView.errorCode = BonuspointsErrorNumber.InternError;
        bonuspointsView.errorMessage = "Data has wrong Version " + model.version;
      }
    } else {
      // no data for parsing
      bonuspointsView.errorCode = BonuspointsErrorNumber.InternError;
      bonuspointsView.errorMessage = "No data for parsing";
    }
    return bonuspointsView;
  }

  /** Read new Points
   */
  public static parseNewBonusPointsFromBonusPointString(version: number, bonuspoints: string): Array<{ label_de: string, points: number }> {
    const newPoints = new Array<{ label_de: string, points: number }>();
    if (!Utils.IsNull(bonuspoints) && bonuspoints.length > 0) {
      if (version === 1) {
        const header = bonuspoints.split("|");
        const header_parts = header[0].split("§"); // header[0] = header_main
        const using_int = parseInt(header_parts[0], 10); // is 1/0 or BonuspointsErrorNumber
        if (using_int === 1) {
          try {
            for (let i = 1; i < header.length; ++i) {
              const act_parts = header[i].split("§"); // header[i] = bonusaction
              const label_de = act_parts[0];
              const points_parts = act_parts[2].split("~"); // act_parts[2] = points
              const new_points = parseInt(points_parts[0], 10); // points_parts[0] = points_new
              const old_points = parseInt(points_parts[1], 10); // points_parts[1] = points_old
              const dif_points = new_points - old_points;
              if (dif_points > 0) {
                newPoints.push({ label_de: label_de, points: dif_points })
              }
            }
            // parsing was suseccsfull
            return newPoints
          } catch (error) {
            // parsing error
            return null;
          }
        } else if (using_int === 0) { // don't use Bonussystem
          return newPoints; // empty array
        }
        else { // Fehler, nur wenn > 1
          return null;
        }
      } else {
        // wrong version
        return null;
      }
    } else {
      // no data for parsing
      return null;
    }
  }

  public addToWallet(internalReference: string, passType: "Voucher" | "Ticket", platform: "Google" | "Apple"): Promise<void> {
    const payload = {
      internalReference,
      passType,
      platform
    };

    const encodedPayload =
      btoa(JSON.stringify(payload));

    const url =
      environment.YourAppServer.BaseURI +
      "wallet_create.aspx?p=" +
      encodeURIComponent(encodedPayload);

    window.open(url, "_system");

    return Promise.resolve();
  }
}
